import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';

import { NationalityManagerCreateActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class NationalityManagerCreateEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getNationalityManagerCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NationalityManagerCreateActions.getNationalityManagerCreate),
      switchMap((action) =>
        this.onboardingProductsService.getNationalityManagerCreate(action.request).pipe(
          map((res) => this.common.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
            NationalityManagerCreateActions.getNationalityManagerCreateSucess({ response: res })
          ),
          catchError((error) =>
            of(
              NationalityManagerCreateActions.getNationalityManagerCreateError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );
}
